/* ============
 * The initial state of the message module.
 * ============
 */
export default {
  patients: [],
  isPatientListLoading: false,
  isPatientMessageListLoading: false,
  patientMessages: [],
  isMessageSending: false,
  patientMessageKeys: [],
  groupedMessages: [],
  patientMessageTotalCount: 0,
  patientsTotalCount: 0,
  isVideoCalling: false,
  videoCall: []
};
